import React from 'react';

import { Icon } from '@chakra-ui/react';

export const InterfaceIcon = props => (
  <Icon viewBox="0 0 256 256" w="full" h="full" color="inherit" {...props}>
    <path d="M176,164a35.94177,35.94177,0,0,0-27.91553,13.30005L96.24805,143.97656a35.89168,35.89168,0,0,0,0-31.95312L148.08447,78.7a35.94594,35.94594,0,1,0-4.333-6.724L91.915,105.29932a36,36,0,1,0,0,45.40136l51.83642,33.32337A35.99234,35.99234,0,1,0,176,164Zm0-136a28,28,0,1,1-28,28A28.03146,28.03146,0,0,1,176,28ZM64,156a28,28,0,1,1,28-28A28.03146,28.03146,0,0,1,64,156Zm112,72a28,28,0,1,1,28-28A28.03146,28.03146,0,0,1,176,228Z" />
  </Icon>
);
